import { useState, useEffect, useCallback } from 'react';

const BASE = '/spring';

const field = {
  width: '100%', padding: '8px 11px', border: '1px solid #ccc', borderRadius: 7,
  fontSize: 13, background: '#fafafa', boxSizing: 'border-box', outline: 'none',
};
const fieldRO = { ...field, background: '#e9f0f7', color: '#555', cursor: 'not-allowed' };

function fmt(date) {
  if (!date) return '—';
  try { return new Date(date).toLocaleDateString('en-IN'); } catch (_) { return date; }
}

export default function ChangePasswordPage() {
  const [employees, setEmployees] = useState([]);
  const [loading,   setLoading]   = useState(false);
  const [err,       setErr]       = useState('');
  const [editing,   setEditing]   = useState(null);   // {userId, userName, contactAddress, contactNumbers, roleId, status}
  const [editForm,  setEditForm]  = useState({});
  const [saveMsg,   setSaveMsg]   = useState(null);   // {text, ok}
  const [saving,    setSaving]    = useState(false);

  const loadEmployees = useCallback(async () => {
    setLoading(true); setErr('');
    try {
      const res = await fetch(`${BASE}/api/files/employees`, { credentials: 'include' });
      if (res.status === 401) { window.location.href = `${BASE}/login`; return; }
      if (!res.ok) { setErr('Failed to load users'); setLoading(false); return; }
      setEmployees(await res.json());
    } catch (e) { setErr(e.message); }
    setLoading(false);
  }, []);

  useEffect(() => { loadEmployees(); }, [loadEmployees]);

  const openEdit = (emp) => {
    setEditing(emp);
    setEditForm({
      userid:        emp.userId,
      username:      emp.userName,
      password:      '',
      address:       emp.contactAddress || '',
      contactnumber: emp.contactNumbers || '',
      bstatus:       emp.status ? 'true' : 'false',
      roleId:        emp.roleId || '6',
    });
    setSaveMsg(null);
  };

  const closeEdit = () => { setEditing(null); setEditForm({}); setSaveMsg(null); };

  const setF = (k, v) => setEditForm(f => ({ ...f, [k]: v }));

  const handleSave = async (e) => {
    e.preventDefault();
    if (editForm.password && editForm.password.length < 6) {
      setSaveMsg({ text: 'Password must be at least 6 characters', ok: false }); return;
    }
    setSaving(true); setSaveMsg(null);
    try {
      const res = await fetch(`${BASE}/api/files/employee/update`, {
        method: 'POST', credentials: 'include',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(editForm),
      });
      const json = await res.json().catch(() => ({}));
      if (res.ok && json.success) {
        setSaveMsg({ text: 'Updated successfully', ok: true });
        await loadEmployees();
      } else {
        setSaveMsg({ text: json.error || 'Update failed', ok: false });
      }
    } catch (e) {
      setSaveMsg({ text: e.message, ok: false });
    }
    setSaving(false);
  };

  return (
    <div style={{ padding: '16px 12px 60px', maxWidth: 900, margin: '0 auto' }}>

      {/* Employee list card */}
      <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,.08)', padding: '18px 16px', marginBottom: 20 }}>
        <div style={{ textAlign: 'center', borderBottom: '2px solid #e0e0e0', paddingBottom: 12, marginBottom: 16, fontSize: 18, fontWeight: 900, color: '#0066CC' }}>
          Login Accounts
        </div>

        {err && (
          <div style={{ padding: '8px 14px', borderRadius: 8, fontSize: 13, background: '#fff5f5', border: '1px solid #feb2b2', color: '#c53030', marginBottom: 12 }}>{err}</div>
        )}

        {loading ? (
          <div style={{ textAlign: 'center', padding: 32, color: '#718096', fontSize: 13 }}>Loading…</div>
        ) : employees.length === 0 ? (
          <div style={{ textAlign: 'center', padding: 32, color: '#718096', fontSize: 13 }}>No accounts found</div>
        ) : (
          <div style={{ overflowX: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 13, minWidth: 600 }}>
              <thead>
                <tr style={{ background: '#0066CC' }}>
                  {['#', 'Name', 'Contact Address', 'Phone', 'Login ID', 'Date', 'Actions'].map(h => (
                    <th key={h} style={{ color: '#fff', padding: '10px 12px', textAlign: 'center', whiteSpace: 'nowrap', fontSize: 13 }}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {employees.map((emp, i) => (
                  <tr key={emp.userId}
                    style={{ borderBottom: '1px solid #eee', background: i % 2 === 1 ? '#f5f9ff' : '#fff' }}
                    onMouseEnter={e => e.currentTarget.style.background = '#eef7ff'}
                    onMouseLeave={e => e.currentTarget.style.background = i % 2 === 1 ? '#f5f9ff' : '#fff'}
                  >
                    <td style={{ padding: '8px 12px', textAlign: 'center' }}>{i + 1}</td>
                    <td style={{ padding: '8px 12px', textAlign: 'center' }}>{emp.userName}</td>
                    <td style={{ padding: '8px 12px', textAlign: 'center', maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{emp.contactAddress || '—'}</td>
                    <td style={{ padding: '8px 12px', textAlign: 'center' }}>{emp.contactNumbers || '—'}</td>
                    <td style={{ padding: '8px 12px', textAlign: 'center', fontWeight: 600 }}>{emp.userId}</td>
                    <td style={{ padding: '8px 12px', textAlign: 'center', whiteSpace: 'nowrap' }}>{fmt(emp.dateRegistered)}</td>
                    <td style={{ padding: '8px 12px', textAlign: 'center' }}>
                      <button
                        onClick={() => editing?.userId === emp.userId ? closeEdit() : openEdit(emp)}
                        style={{
                          padding: '5px 12px', borderRadius: 6, border: 'none', cursor: 'pointer', fontSize: 12, fontWeight: 600,
                          background: editing?.userId === emp.userId ? '#e53e3e' : '#0066CC',
                          color: '#fff',
                        }}
                      >
                        {editing?.userId === emp.userId ? 'Cancel' : '✏️ Edit'}
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Inline edit form */}
      {editing && (
        <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 10px rgba(0,0,0,.08)', padding: '18px 16px', maxWidth: 520, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', borderBottom: '2px solid #e0e0e0', paddingBottom: 12, marginBottom: 18, fontSize: 16, fontWeight: 900, color: '#0066CC' }}>
            Update Profile — {editing.userName}
          </div>

          {saveMsg && (
            <div style={{ marginBottom: 14, padding: '9px 14px', borderRadius: 8, fontSize: 13, background: saveMsg.ok ? '#f0fff4' : '#fff5f5', border: `1px solid ${saveMsg.ok ? '#9ae6b4' : '#feb2b2'}`, color: saveMsg.ok ? '#276749' : '#c53030', display: 'flex', justifyContent: 'space-between' }}>
              {saveMsg.text}
              <button onClick={() => setSaveMsg(null)} style={{ background: 'none', border: 'none', cursor: 'pointer', fontSize: 16 }}>✕</button>
            </div>
          )}

          <form onSubmit={handleSave}>
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
              <thead>
                <tr><th colSpan={2} style={{ background: '#0066CC', color: '#fff', padding: '10px 14px', textAlign: 'center', fontSize: 13 }}>Profile Details</th></tr>
              </thead>
              <tbody>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 14px', fontWeight: 600, color: '#555', width: '38%', whiteSpace: 'nowrap' }}>Login ID</td>
                  <td style={{ padding: '10px 14px' }}>
                    <input type="text" value={editForm.userid} readOnly style={fieldRO} />
                  </td>
                </tr>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 14px', fontWeight: 600, color: '#555' }}>User Name</td>
                  <td style={{ padding: '10px 14px' }}>
                    <input type="text" value={editForm.username} readOnly style={fieldRO} />
                  </td>
                </tr>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 14px', fontWeight: 600, color: '#555' }}>New Password</td>
                  <td style={{ padding: '10px 14px' }}>
                    <input type="password" value={editForm.password} autoComplete="new-password"
                      placeholder="Leave blank to keep current"
                      onChange={e => setF('password', e.target.value)}
                      style={field} />
                  </td>
                </tr>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 14px', fontWeight: 600, color: '#555' }}>Contact Address</td>
                  <td style={{ padding: '10px 14px' }}>
                    <textarea value={editForm.address} rows={3}
                      onChange={e => setF('address', e.target.value)}
                      style={{ ...field, resize: 'vertical', minHeight: 70 }} />
                  </td>
                </tr>
                <tr style={{ borderBottom: '1px solid #eee' }}>
                  <td style={{ padding: '10px 14px', fontWeight: 600, color: '#555' }}>Contact Number</td>
                  <td style={{ padding: '10px 14px' }}>
                    <input type="tel" value={editForm.contactnumber} maxLength={10}
                      onChange={e => setF('contactnumber', e.target.value.replace(/\D/g, '').slice(0, 10))}
                      style={field} />
                  </td>
                </tr>
                <tr>
                  <td style={{ padding: '10px 14px', fontWeight: 600, color: '#555' }}>Status</td>
                  <td style={{ padding: '10px 14px' }}>
                    <select value={editForm.bstatus} onChange={e => setF('bstatus', e.target.value)} style={field}>
                      <option value="true">ACTIVE</option>
                      <option value="false">DISABLE</option>
                    </select>
                  </td>
                </tr>
              </tbody>
            </table>

            <div style={{ display: 'flex', gap: 10, marginTop: 14 }}>
              <button type="button" onClick={closeEdit}
                style={{ flex: 1, padding: 12, background: '#f5f5f5', color: '#555', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer' }}>
                Cancel
              </button>
              <button type="submit" disabled={saving}
                style={{ flex: 2, padding: 12, background: saving ? '#99b8d8' : '#0066CC', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 700, cursor: saving ? 'not-allowed' : 'pointer' }}>
                {saving ? 'Saving…' : 'Update Profile'}
              </button>
            </div>
          </form>
        </div>
      )}
    </div>
  );
}
